 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A0_FRONTCOVER from '@/components/00_Frontcover'
 import A1_TITLEPAGE from '@/components/01_titlepage'
 import A2_COPYRIGHT from '@/components/02_copyright'
 import A2_TABLE_OF_CONTENTS from '@/components/02_Table_of_Contents'
 import A3_PREFACE from '@/components/03_Preface'
 import A4_PHOTOGRAPH_SOURCES from '@/components/04_Photograph_Sources'
 import A5_INTRODUCTION from '@/components/05_Introduction'
 import A6_00_CHAPTER_ONE from '@/components/06_00_Chapter_One'
 import A6_01_CHAPTER_ONE from '@/components/06_01_Chapter_One'
 import A6_02_CHAPTER_ONE from '@/components/06_02_Chapter_One'
 import A6_03_CHAPTER_ONE from '@/components/06_03_Chapter_One'
 import A6_04_CHAPTER_ONE from '@/components/06_04_Chapter_One'
 import A6_05_CHAPTER_ONE from '@/components/06_05_Chapter_One'
 import A6_06_CHAPTER_ONE from '@/components/06_06_Chapter_One'
 import A6_07_CHAPTER_ONE from '@/components/06_07_Chapter_One'
 import A6_08_CHAPTER_ONE from '@/components/06_08_Chapter_One'
 import A6_09_CHAPTER_ONE from '@/components/06_09_Chapter_One'
 import A6_10_CHAPTER_ONE from '@/components/06_10_Chapter_One'
 import A6_11_CHAPTER_ONE from '@/components/06_11_Chapter_One'
 import A6_12_CHAPTER_ONE from '@/components/06_12_Chapter_One'
 import A6_13_CHAPTER_ONE from '@/components/06_13_Chapter_One'
 import A6_14_CHAPTER_ONE from '@/components/06_14_Chapter_One'
 import A6_15_CHAPTER_ONE from '@/components/06_15_Chapter_One'
 import A6_16_CHAPTER_ONE from '@/components/06_16_Chapter_One'
 import A6_17_CHAPTER_ONE from '@/components/06_17_Chapter_One'
 import A6_18_CHAPTER_ONE from '@/components/06_18_Chapter_One'
 import A6_19_CHAPTER_ONE from '@/components/06_19_Chapter_One'
 import A6_20_CHAPTER_ONE from '@/components/06_20_Chapter_One'
 import A6_21_CHAPTER_ONE from '@/components/06_21_Chapter_One'
 import A6_22_CHAPTER_ONE from '@/components/06_22_Chapter_One'
 import A7_00_CHAPTER_TWO from '@/components/07_00_Chapter_Two'
 import A7_01_CHAPTER_TWO from '@/components/07_01_Chapter_Two'
 import A7_02_CHAPTER_TWO from '@/components/07_02_Chapter_Two'
 import A7_03_CHAPTER_TWO from '@/components/07_03_Chapter_Two'
 import A7_04_CHAPTER_TWO from '@/components/07_04_Chapter_Two'
 import A7_05_CHAPTER_TWO from '@/components/07_05_Chapter_Two'
 import A7_06_CHAPTER_TWO from '@/components/07_06_Chapter_Two'
 import A7_07_CHAPTER_TWO from '@/components/07_07_Chapter_Two'
 import A7_08_CHAPTER_TWO from '@/components/07_08_Chapter_Two'
 import A7_09_CHAPTER_TWO from '@/components/07_09_Chapter_Two'
 import A7_10_CHAPTER_TWO from '@/components/07_10_Chapter_Two'
 import A7_11_CHAPTER_TWO from '@/components/07_11_Chapter_Two'
 import A7_12_CHAPTER_TWO from '@/components/07_12_Chapter_Two'
 import A7_13_CHAPTER_TWO from '@/components/07_13_Chapter_Two'
 import A7_14_CHAPTER_TWO from '@/components/07_14_Chapter_Two'
 import A7_15_CHAPTER_TWO from '@/components/07_15_Chapter_Two'
 import A7_16_CHAPTER_TWO from '@/components/07_16_Chapter_Two'
 import A7_17_CHAPTER_TWO from '@/components/07_17_Chapter_Two'
 import A7_18_CHAPTER_TWO from '@/components/07_18_Chapter_Two'
 import A7_19_CHAPTER_TWO from '@/components/07_19_Chapter_Two'
 import A7_20_CHAPTER_TWO from '@/components/07_20_Chapter_Two'
 import A7_21_CHAPTER_TWO from '@/components/07_21_Chapter_Two'
 import A7_22_CHAPTER_TWO from '@/components/07_22_Chapter_Two'
 import A8_00_CHAPTER_THREE from '@/components/08_00_Chapter_Three'
 import A8_01_CHAPTER_THREE from '@/components/08_01_Chapter_Three'
 import A8_02_CHAPTER_THREE from '@/components/08_02_Chapter_Three'
 import A8_03_CHAPTER_THREE from '@/components/08_03_Chapter_Three'
 import A8_04_CHAPTER_THREE from '@/components/08_04_Chapter_Three'
 import A8_05_CHAPTER_THREE from '@/components/08_05_Chapter_Three'
 import A8_06_CHAPTER_THREE from '@/components/08_06_Chapter_Three'
 import A8_07_CHAPTER_THREE from '@/components/08_07_Chapter_Three'
 import A8_08_CHAPTER_THREE from '@/components/08_08_Chapter_Three'
 import A8_09_CHAPTER_THREE from '@/components/08_09_Chapter_Three'
 import A8_10_CHAPTER_THREE from '@/components/08_10_Chapter_Three'
 import A8_11_CHAPTER_THREE from '@/components/08_11_Chapter_Three'
 import A8_12_CHAPTER_THREE from '@/components/08_12_Chapter_Three'
 import A8_13_CHAPTER_THREE from '@/components/08_13_Chapter_Three'
 import A8_14_CHAPTER_THREE from '@/components/08_14_Chapter_Three'
 import A8_15_CHAPTER_THREE from '@/components/08_15_Chapter_Three'
 import A8_16_CHAPTER_THREE from '@/components/08_16_Chapter_Three'
 import A8_17_CHAPTER_THREE from '@/components/08_17_Chapter_Three'
 import A8_18_CHAPTER_THREE from '@/components/08_18_Chapter_Three'
 import A8_19_CHAPTER_THREE from '@/components/08_19_Chapter_Three'
 import A8_20_CHAPTER_THREE from '@/components/08_20_Chapter_Three'
 import A8_21_CHAPTER_THREE from '@/components/08_21_Chapter_Three'
 import A8_22_CHAPTER_THREE from '@/components/08_22_Chapter_Three'
 import A8_23_CHAPTER_THREE from '@/components/08_23_Chapter_Three'
 import A8_24_CHAPTER_THREE from '@/components/08_24_Chapter_Three'
 import A8_25_CHAPTER_THREE from '@/components/08_25_Chapter_Three'
 import A8_26_CHAPTER_THREE from '@/components/08_26_Chapter_Three'
 import A8_27_CHAPTER_THREE from '@/components/08_27_Chapter_Three'
 import A9_00_CHAPTER_FOUR from '@/components/09_00_Chapter_Four'
 import A9_01_CHAPTER_FOUR from '@/components/09_01_Chapter_Four'
 import A9_02_CHAPTER_FOUR from '@/components/09_02_Chapter_Four'
 import A9_03_CHAPTER_FOUR from '@/components/09_03_Chapter_Four'
 import A9_04_CHAPTER_FOUR from '@/components/09_04_Chapter_Four'
 import A9_05_CHAPTER_FOUR from '@/components/09_05_Chapter_Four'
 import A9_06_CHAPTER_FOUR from '@/components/09_06_Chapter_Four'
 import A9_07_CHAPTER_FOUR from '@/components/09_07_Chapter_Four'
 import A9_08_CHAPTER_FOUR from '@/components/09_08_Chapter_Four'
 import A9_09_CHAPTER_FOUR from '@/components/09_09_Chapter_Four'
 import A9_10_CHAPTER_FOUR from '@/components/09_10_Chapter_Four'
 import A9_11_CHAPTER_FOUR from '@/components/09_11_Chapter_Four'
 import A9_12_CHAPTER_FOUR from '@/components/09_12_Chapter_Four'
 import A9_13_CHAPTER_FOUR from '@/components/09_13_Chapter_Four'
 import A9_14_CHAPTER_FOUR from '@/components/09_14_Chapter_Four'
 import A9_15_CHAPTER_FOUR from '@/components/09_15_Chapter_Four'
 import A9_16_CHAPTER_FOUR from '@/components/09_16_Chapter_Four'
 import A9_17_CHAPTER_FOUR from '@/components/09_17_Chapter_Four'
 import A9_18_CHAPTER_FOUR from '@/components/09_18_Chapter_Four'
 import A9_19_CHAPTER_FOUR from '@/components/09_19_Chapter_Four'
 import A9_20_CHAPTER_FOUR from '@/components/09_20_Chapter_Four'
 import A0_00_CHAPTER_FIVE from '@/components/10_00_Chapter_Five'
 import A0_00A_CHAPTER_FIVE from '@/components/10_00a_Chapter_Five'
 import A0_01_CHAPTER_FIVE from '@/components/10_01_Chapter_Five'
 import A0_02_CHAPTER_FIVE from '@/components/10_02_Chapter_Five'
 import A0_03_CHAPTER_FIVE from '@/components/10_03_Chapter_Five'
 import A0_04_CHAPTER_FIVE from '@/components/10_04_Chapter_Five'
 import A0_05_CHAPTER_FIVE from '@/components/10_05_Chapter_Five'
 import A0_06_CHAPTER_FIVE from '@/components/10_06_Chapter_Five'
 import A0_07_CHAPTER_FIVE from '@/components/10_07_Chapter_Five'
 import A0_08_CHAPTER_FIVE from '@/components/10_08_Chapter_Five'
 import A0_09_CHAPTER_FIVE from '@/components/10_09_Chapter_Five'
 import A0_10_CHAPTER_FIVE from '@/components/10_10_Chapter_Five'
 import A0_11_CHAPTER_FIVE from '@/components/10_11_Chapter_Five'
 import A0_12_CHAPTER_FIVE from '@/components/10_12_Chapter_Five'
 import A0_13_CHAPTER_FIVE from '@/components/10_13_Chapter_Five'
 import A0_14_CHAPTER_FIVE from '@/components/10_14_Chapter_Five'
 import A0_15_CHAPTER_FIVE from '@/components/10_15_Chapter_Five'
 import A0_16_CHAPTER_FIVE from '@/components/10_16_Chapter_Five'
 import A0_17_CHAPTER_FIVE from '@/components/10_17_Chapter_Five'
 import A0_18_CHAPTER_FIVE from '@/components/10_18_Chapter_Five'
 import A0_19_CHAPTER_FIVE from '@/components/10_19_Chapter_Five'
 import A0_20_CHAPTER_FIVE from '@/components/10_20_Chapter_Five'
 import A1_00_CHAPTER_SIX from '@/components/11_00_Chapter_Six'
 import A1_01_CHAPTER_SIX from '@/components/11_01_Chapter_Six'
 import A1_02_CHAPTER_SIX from '@/components/11_02_Chapter_Six'
 import A1_03_CHAPTER_SIX from '@/components/11_03_Chapter_Six'
 import A1_04_CHAPTER_SIX from '@/components/11_04_Chapter_Six'
 import A1_05_CHAPTER_SIX from '@/components/11_05_Chapter_Six'
 import A1_06_CHAPTER_SIX from '@/components/11_06_Chapter_Six'
 import A1_07_CHAPTER_SIX from '@/components/11_07_Chapter_Six'
 import A1_08_CHAPTER_SIX from '@/components/11_08_Chapter_Six'
 import A1_09_CHAPTER_SIX from '@/components/11_09_Chapter_Six'
 import A1_10_CHAPTER_SIX from '@/components/11_10_Chapter_Six'
 import A1_11_CHAPTER_SIX from '@/components/11_11_Chapter_Six'
 import A1_12_CHAPTER_SIX from '@/components/11_12_Chapter_Six'
 import A1_13_CHAPTER_SIX from '@/components/11_13_Chapter_Six'
 import A1_14_CHAPTER_SIX from '@/components/11_14_Chapter_Six'
 import A1_15_CHAPTER_SIX from '@/components/11_15_Chapter_Six'
 import A1_16_CHAPTER_SIX from '@/components/11_16_Chapter_Six'
 import A1_17_CHAPTER_SIX from '@/components/11_17_Chapter_Six'
 import A1_18_CHAPTER_SIX from '@/components/11_18_Chapter_Six'
 import A1_19_CHAPTER_SIX from '@/components/11_19_Chapter_Six'
 import A1_20_CHAPTER_SIX from '@/components/11_20_Chapter_Six'
 import A1_21_CHAPTER_SIX from '@/components/11_21_Chapter_Six'
 import A2_00_CHAPTER_SEVEN from '@/components/12_00_Chapter_Seven'
 import A2_01_CHAPTER_SEVEN from '@/components/12_01_Chapter_Seven'
 import A2_02_CHAPTER_SEVEN from '@/components/12_02_Chapter_Seven'
 import A2_03_CHAPTER_SEVEN from '@/components/12_03_Chapter_Seven'
 import A2_04_CHAPTER_SEVEN from '@/components/12_04_Chapter_Seven'
 import A2_05_CHAPTER_SEVEN from '@/components/12_05_Chapter_Seven'
 import A2_06_CHAPTER_SEVEN from '@/components/12_06_Chapter_Seven'
 import A2_07_CHAPTER_SEVEN from '@/components/12_07_Chapter_Seven'
 import A2_08_CHAPTER_SEVEN from '@/components/12_08_Chapter_Seven'
 import A2_09_CHAPTER_SEVEN from '@/components/12_09_Chapter_Seven'
 import A2_10_CHAPTER_SEVEN from '@/components/12_10_Chapter_Seven'
 import A2_11_CHAPTER_SEVEN from '@/components/12_11_Chapter_Seven'
 import A2_12_CHAPTER_SEVEN from '@/components/12_12_Chapter_Seven'
 import A2_13_CHAPTER_SEVEN from '@/components/12_13_Chapter_Seven'
 import A2_14_CHAPTER_SEVEN from '@/components/12_14_Chapter_Seven'
 import A2_15_CHAPTER_SEVEN from '@/components/12_15_Chapter_Seven'
 import A2_16_CHAPTER_SEVEN from '@/components/12_16_Chapter_Seven'
 import A2_17_CHAPTER_SEVEN from '@/components/12_17_Chapter_Seven'
 import A3_00_CHAPTER_EIGHT from '@/components/13_00_Chapter_Eight'
 import A3_01_CHAPTER_EIGHT from '@/components/13_01_Chapter_Eight'
 import A3_02_CHAPTER_EIGHT from '@/components/13_02_Chapter_Eight'
 import A3_03_CHAPTER_EIGHT from '@/components/13_03_Chapter_Eight'
 import A3_04_CHAPTER_EIGHT from '@/components/13_04_Chapter_Eight'
 import A3_05_CHAPTER_EIGHT from '@/components/13_05_Chapter_Eight'
 import A3_06_CHAPTER_EIGHT from '@/components/13_06_Chapter_Eight'
 import A3_07_CHAPTER_EIGHT from '@/components/13_07_Chapter_Eight'
 import A3_08_CHAPTER_EIGHT from '@/components/13_08_Chapter_Eight'
 import A3_09_CHAPTER_EIGHT from '@/components/13_09_Chapter_Eight'
 import A3_10_CHAPTER_EIGHT from '@/components/13_10_Chapter_Eight'
 import A3_11_CHAPTER_EIGHT from '@/components/13_11_Chapter_Eight'
 import A3_12_CHAPTER_EIGHT from '@/components/13_12_Chapter_Eight'
 import A3_13_CHAPTER_EIGHT from '@/components/13_13_Chapter_Eight'
 import A3_14_CHAPTER_EIGHT from '@/components/13_14_Chapter_Eight'
 import A3_15_CHAPTER_EIGHT from '@/components/13_15_Chapter_Eight'
 import A3_16_CHAPTER_EIGHT from '@/components/13_16_Chapter_Eight'
 import A3_17_CHAPTER_EIGHT from '@/components/13_17_Chapter_Eight'
 import A3_18_CHAPTER_EIGHT from '@/components/13_18_Chapter_Eight'
 import A3_19_CHAPTER_EIGHT from '@/components/13_19_Chapter_Eight'
 import A3_20_CHAPTER_EIGHT from '@/components/13_20_Chapter_Eight'
 import A3_21_CHAPTER_EIGHT from '@/components/13_21_Chapter_Eight'
 import A3_22_CHAPTER_EIGHT from '@/components/13_22_Chapter_Eight'
 import A3_23_CHAPTER_EIGHT from '@/components/13_23_Chapter_Eight'
 import A3_24_CHAPTER_EIGHT from '@/components/13_24_Chapter_Eight'
 import A4_00_CHAPTER_NINE from '@/components/14_00_Chapter_Nine'
 import A4_01_CHAPTER_NINE from '@/components/14_01_Chapter_Nine'
 import A4_02_CHAPTER_NINE from '@/components/14_02_Chapter_Nine'
 import A4_03_CHAPTER_NINE from '@/components/14_03_Chapter_Nine'
 import A4_04_CHAPTER_NINE from '@/components/14_04_Chapter_Nine'
 import A4_05_CHAPTER_NINE from '@/components/14_05_Chapter_Nine'
 import A4_06_CHAPTER_NINE from '@/components/14_06_Chapter_Nine'
 import A4_07_CHAPTER_NINE from '@/components/14_07_Chapter_Nine'
 import A4_08_CHAPTER_NINE from '@/components/14_08_Chapter_Nine'
 import A4_09_CHAPTER_NINE from '@/components/14_09_Chapter_Nine'
 import A4_10_CHAPTER_NINE from '@/components/14_10_Chapter_Nine'
 import A4_11_CHAPTER_NINE from '@/components/14_11_Chapter_Nine'
 import A4_12_CHAPTER_NINE from '@/components/14_12_Chapter_Nine'
 import A4_13_CHAPTER_NINE from '@/components/14_13_Chapter_Nine'
 import A4_14_CHAPTER_NINE from '@/components/14_14_Chapter_Nine'
 import A4_15_CHAPTER_NINE from '@/components/14_15_Chapter_Nine'
 import A4_16_CHAPTER_NINE from '@/components/14_16_Chapter_Nine'
 import A4_17_CHAPTER_NINE from '@/components/14_17_Chapter_Nine'
 import A4_18_CHAPTER_NINE from '@/components/14_18_Chapter_Nine'
 import A4_19_CHAPTER_NINE from '@/components/14_19_Chapter_Nine'
 import A4_20_CHAPTER_NINE from '@/components/14_20_Chapter_Nine'
 import A5_00_CHAPTER_TEN from '@/components/15_00_Chapter_Ten'
 import A5_01_CHAPTER_TEN from '@/components/15_01_Chapter_Ten'
 import A5_02_CHAPTER_TEN from '@/components/15_02_Chapter_Ten'
 import A5_03_CHAPTER_TEN from '@/components/15_03_Chapter_Ten'
 import A5_04_CHAPTER_TEN from '@/components/15_04_Chapter_Ten'
 import A5_05_CHAPTER_TEN from '@/components/15_05_Chapter_Ten'
 import A5_06_CHAPTER_TEN from '@/components/15_06_Chapter_Ten'
 import A5_07_CHAPTER_TEN from '@/components/15_07_Chapter_Ten'
 import A5_08_CHAPTER_TEN from '@/components/15_08_Chapter_Ten'
 import A5_09_CHAPTER_TEN from '@/components/15_09_Chapter_Ten'
 import A5_10_CHAPTER_TEN from '@/components/15_10_Chapter_Ten'
 import A5_11_CHAPTER_TEN from '@/components/15_11_Chapter_Ten'
 import A5_12_CHAPTER_TEN from '@/components/15_12_Chapter_Ten'
 import A5_13_CHAPTER_TEN from '@/components/15_13_Chapter_Ten'
 import A5_14_CHAPTER_TEN from '@/components/15_14_Chapter_Ten'
 import A6_00_CHAPTER_ELEVEN from '@/components/16_00_Chapter_Eleven'
 import A6_01_CHAPTER_ELEVEN from '@/components/16_01_Chapter_Eleven'
 import A6_02_CHAPTER_ELEVEN from '@/components/16_02_Chapter_Eleven'
 import A6_03_CHAPTER_ELEVEN from '@/components/16_03_Chapter_Eleven'
 import A6_04_CHAPTER_ELEVEN from '@/components/16_04_Chapter_Eleven'
 import A6_05_CHAPTER_ELEVEN from '@/components/16_05_Chapter_Eleven'
 import A6_06_CHAPTER_ELEVEN from '@/components/16_06_Chapter_Eleven'
 import A6_07_CHAPTER_ELEVEN from '@/components/16_07_Chapter_Eleven'
 import A6_08_CHAPTER_ELEVEN from '@/components/16_08_Chapter_Eleven'
 import A6_09_CHAPTER_ELEVEN from '@/components/16_09_Chapter_Eleven'
 import A6_10_CHAPTER_ELEVEN from '@/components/16_10_Chapter_Eleven'
 import A6_11_CHAPTER_ELEVEN from '@/components/16_11_Chapter_Eleven'
 import A6_12_CHAPTER_ELEVEN from '@/components/16_12_Chapter_Eleven'
 import A6_13_CHAPTER_ELEVEN from '@/components/16_13_Chapter_Eleven'
 import A6_14_CHAPTER_ELEVEN from '@/components/16_14_Chapter_Eleven'
 import A6_15_CHAPTER_ELEVEN from '@/components/16_15_Chapter_Eleven'
 import A6_16_CHAPTER_ELEVEN from '@/components/16_16_Chapter_Eleven'
 import A6_17_CHAPTER_ELEVEN from '@/components/16_17_Chapter_Eleven'
 import A6_18_CHAPTER_ELEVEN from '@/components/16_18_Chapter_Eleven'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/02_Table_of_Contents",
 			"name" : "02_Table_of_Contents",
 			"component" : A2_TABLE_OF_CONTENTS
 		},
 		{
 			"path" : "/03_Preface",
 			"name" : "03_Preface",
 			"component" : A3_PREFACE
 		},
 		{
 			"path" : "/04_Photograph_Sources",
 			"name" : "04_Photograph_Sources",
 			"component" : A4_PHOTOGRAPH_SOURCES
 		},
 		{
 			"path" : "/05_Introduction",
 			"name" : "05_Introduction",
 			"component" : A5_INTRODUCTION
 		},
 		{
 			"path" : "/06_00_Chapter_One",
 			"name" : "06_00_Chapter_One",
 			"component" : A6_00_CHAPTER_ONE
 		},
 		{
 			"path" : "/06_01_Chapter_One",
 			"name" : "06_01_Chapter_One",
 			"component" : A6_01_CHAPTER_ONE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js